


















export default {
  name: 'enrollee-sort',
  props: {
    title: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    selected: {},
    show: {
      default: false,
      type: Boolean,
    },
  },
};
